import "./alertModal.scss";
import React, { useRef } from "react";
import TextInput from "../textInput/TextInput";
import closeIcon from "../../images/modal/close-icon.svg";
import YellowButton from "../buttons/defaultButton/yellowButton/YellowButton";
import useOnClickOutside from "../../helpers/useOnClickOutside";
import WhiteButton from "../buttons/defaultButton/whiteButton/WhiteButton";
import GreenButton from "../buttons/defaultButton/greenButton/GreenButton";

const AlertModal = ({ title, isOpen = true, setIsOpen, onConfirm }) => {
    const modalRef = useRef();

    useOnClickOutside(modalRef, () => setIsOpen(false));

    return (
        <>
            {isOpen && (
                <div className="modal-overlay">
                    <div className="alert-modal" ref={modalRef}>
                        <img
                            src={closeIcon}
                            alt="close"
                            className="alert-modal__close-btn"
                            onClick={() => setIsOpen(false)}
                        />
                        <div className="alert-modal__header">{title}</div>
                        <div className="alert-modal__body">
                            Ви впевнені в тому що хочете зробити цю версію документа публічною?
                        </div>
                        <div className="alert-modal__footer">
                            <WhiteButton
                                text={"Ні"}
                                padding={"14px 36px"}
                                width={"23px"}
                                onClick={() => setIsOpen(false)}
                            />
                            <GreenButton text={"Так"} padding={"14px 36px"} width={"25px"} onClick={onConfirm} />
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default AlertModal;
